import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import SharedClosetAccess from "@/components/SharedClosetAccess";
import { Link } from "lucide-react";
const SharedAccessButton = () => {
  const [open, setOpen] = useState(false);
  return <>
      

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="text-center">Access Shared Closet</DialogTitle>
          </DialogHeader>
          <SharedClosetAccess onAccessGranted={() => setOpen(false)} redirectPath="/digital-closet" />
        </DialogContent>
      </Dialog>
    </>;
};
export default SharedAccessButton;